export default "__VITE_ASSET__f180f3d1__"